document.addEventListener("DOMContentLoaded", function () {
  const prodCatCarousel = document.querySelector(".testimonials-carousel__swiper");

  if (prodCatCarousel) {
    const swiper = new Swiper(".testimonials-carousel__swiper", {
		// Optional parameters
		direction: "horizontal",
		loop: true,
		effect: "slide",
		// autoplay: { delay: 5000 },
		speed: 1000,
		autoHeight: true,
		// calculateHeight:true,
		keyboard: true,
		centeredSlides: true,
		spaceBetween: 15,
		grabCursor: false,
		breakpoints: {
			1800: {
				slidesPerView: 5,
				spaceBetween: 22,
			},
			1440: {
				slidesPerView: 3.5,
			},
			1024: {
				slidesPerView: 3.25,
			},
			992: {
				slidesPerView: 3.25,
			},
			925: {
				slidesPerView: 3.5,
			},
			810: {
				slidesPerView: 3.25,
			},
			735: {
				slidesPerView: 2.75,
			},
			675: {
				slidesPerView: 2.8,
			},
			650: {
				slidesPerView: 2.5,
			},
			600: {
				slidesPerView: 2.5,
			},
			585: {
				slidesPerView: 2.25,
			},
			520: {
				slidesPerView: 2,
			},
			495: {
				slidesPerView: 1.85,
			},
			450: {
				slidesPerView: 1.75,
			},
			375: {
				slidesPerView: 1.55,
			},
		},

		// If we need pagination
		pagination: {
			el: ".swiper-pagination",
		},

		// Navigation arrows
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
    swiper.updateAutoHeight();
  }
});
